module.exports = __webpack_public_path__ + "static/media/artel.48a0dda5.png";